import { TABLE } from 'reporting-data/constants/chartTypes';
import { getDimensions } from 'reporting-data/report/configReportGetters';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
export const getIsReportValidForTotalsColumnCheckbox = ({
  report
}) => {
  var _getDimensions;
  return isConfigReport(report) && getReportChartType(report) === TABLE && ((_getDimensions = getDimensions(report)) === null || _getDimensions === void 0 ? void 0 : _getDimensions.size) > 1;
};